/* CostumeGlamour navigation. One listener set per header, including editor reloads. */
(() => {
  let controller;
  let frame = 0;
  let observer;
  const syncFeed = () => {
    const target = document.querySelector('#dynamic-collection-feed');
    const source = document.querySelector('#MainContent .custom__collection-wrapper');
    if (!target) return;
    target.replaceChildren();
    if (!source) return;
    const copy = source.cloneNode(true);
    copy.style.removeProperty('display');
    target.append(copy);
  };
  const init = () => {
    controller?.abort();
    observer?.disconnect();
    cancelAnimationFrame(frame);
    controller = new AbortController();
    const { signal } = controller;
    const wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;
    const menus = [...wrapper.querySelectorAll('.header__inline-menu details')];
    const overlay = document.body.dataset.cgOverlayHeader === 'true';
    const update = () => {
      const open = menus.some(menu => menu.open);
      if (overlay) {
        wrapper.classList.toggle('scrolled-below-banner', window.scrollY >= 100 || open);
        const header = document.querySelector('.shopify-section-header-sticky');
        if (header) {
          header.style.position = window.scrollY > 37 ? 'fixed' : 'absolute';
          header.style.marginTop = window.scrollY > 37 ? '0' : '38px';
        }
      }
    };
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };
    const closeMenus = () => {
      // Do not collapse a menu while a keyboard user is interacting inside it.
      menus.forEach(menu => {
        if (!menu.contains(document.activeElement)) menu.open = false;
      });
      update();
    };
    menus.forEach(menu => {
      menu.addEventListener('mouseenter', () => {
        if (!matchMedia('(hover: hover)').matches) return;
        menus.forEach(other => { if (other !== menu && !other.contains(document.activeElement)) other.open = false; });
        menu.open = true;
        update();
      }, { signal });
      menu.addEventListener('toggle', update, { signal });
    });
    wrapper.querySelectorAll('.header__inline-menu > ul > li > a').forEach(link => {
      link.addEventListener('mouseenter', closeMenus, { signal });
    });
    wrapper.addEventListener('mouseleave', closeMenus, { signal });
    if (overlay) window.addEventListener('scroll', schedule, { passive: true, signal });
    window.addEventListener('resize', schedule, { passive: true, signal });
    syncFeed();
    const main = document.querySelector('#MainContent');
    if (main) {
      observer = new MutationObserver(records => {
        if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
          (node.matches?.('.custom__collection-wrapper') || node.querySelector?.('.custom__collection-wrapper'))))) syncFeed();
      });
      observer.observe(main, { childList: true, subtree: true });
    }
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));
})();
